"use strict";
$(function ($) {
  /* ドロワーメニュー */
   /* ----- 簡単なハンバーガーメニュー ----- */
  $('#js-hamburger').on('click', function () {
    $('#js-hamburger, #js-drawer-menu').toggleClass('is-openSP');
  });

  $("#js-hamburger").click(function () {
    $(this).toggleClass('active');
  });

  // ハンバーガーメニュー内をクリックしらたらハンバーガーメニューを閉じる
  $('#js-drawer-menu a[href]').on('click', function () {
    $('#js-hamburger').trigger('click')
  });
});

/* ----- ヘッダーシャドー ----- */
$(function () {
  $(window).on('scroll', function () {
    if ($('.fv, .fvSub').height() < $(this).scrollTop()) {
      $('.header').addClass('change-color');
    } else {
      $('.header').removeClass('change-color');
    }
    if ($('.fv, .fvSub').height() < $(this).scrollTop()) {
      $('.header__logo').addClass('is-active');
    } else {
      $('.header__logo').removeClass('is-active');
    }
  });
});

/* ----- メガメニュー ----- */
document.addEventListener('DOMContentLoaded', function() {
  const megaMenuBtn = document.querySelector('.megaMenu__btn');
  const megaMenu = document.querySelector('.megaMenu');

  megaMenuBtn.addEventListener('mouseenter', function() {
    megaMenu.style.opacity = '1';
    megaMenu.style.visibility = 'visible'; // オプションで追加
  });

  megaMenuBtn.addEventListener('mouseleave', function() {
    megaMenu.style.opacity = '0';
    megaMenu.style.visibility = 'hidden'; // オプションで追加
  });

  // megaMenu自体にマウスを載せた場合も表示を維持するための処理
  megaMenu.addEventListener('mouseenter', function() {
    megaMenu.style.opacity = '1';
    megaMenu.style.visibility = 'visible'; // オプションで追加
  });

  megaMenu.addEventListener('mouseleave', function() {
    megaMenu.style.opacity = '0';
    megaMenu.style.visibility = 'hidden'; // オプションで追加
  });
});

/* ----- qa ----- */
$('.qa__label').click(function() {
  $(this).next().stop().slideToggle(400);
  $(this).toggleClass('is-active');
});

// $('.qa__label').click(function() {
//   $(this).next('.qa__value').stop().slideToggle(400);
//   $(this).toggleClass('is-active');
// });





/* ----- 年月別アーカイブのアコーディオン ----- */
$(".side__year").on("click", function() {
  // side__yearの中にある子要素のchildクラスをターゲットにする
  $(this).find(".child").slideToggle();
  $(this).toggleClass("is-active");
});



/* ----- fvースライダー ----- */
if (document.body.classList.contains('top-page')) {
  const splide = new Splide(".splide__fv", {
    // Splideの設定
    type: "fade", // フェード
    autoplay: true, // 自動再生
    rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す
    pauseOnHover: false,
    pauseOnFocus: false,
    arrows: false, // 矢印ボタンを非表示
    interval: 5000,
    speed: 2000,
    perPage: 1,
    classes: {
      pagination: "splide__pagination your-class-pagination",
      page: "splide__pagination__page your-class-page",
    },
  }).mount();
}


/* ----- スムースクロール ----- */
// 固定ヘッダー（固定しない場合は = 0）
const headerHeight = document.querySelector('header').offsetHeight;
// スマホサイズの時の追加オフセット（必要に応じて調整）
const mobileOffset = -100; // 50px 追加オフセット
// ページ内のスムーススクロール
for (const link of document.querySelectorAll('a[href*="#"]')) {
  link.addEventListener('click', (e) => {
    const hash = e.currentTarget.hash;
    const target = document.getElementById(hash.slice(1));

    // ページトップへ("#"と"#top"）
    if (!hash || hash === '#top') {
      e.preventDefault();
      window.scrollTo({
        top: 1, // iOSのChromeで固定ヘッダーが動くバグがあるため0ではなく1に
        behavior: 'smooth',
      });

    // アンカーへ
    } else if (target) {
      e.preventDefault();
      let position = target.getBoundingClientRect().top + window.scrollY - headerHeight;

      // スマホサイズの場合の追加オフセット
      if (window.innerWidth <= 768) { // 768px 以下をスマホと判断
        position += mobileOffset;
      }

      window.scrollTo({
        top: position,
        behavior: "smooth",
      });

      // URLにハッシュを含める
      history.pushState(null, '', hash);
    }
  });
};
// 別ページ遷移後にスムーススクロール
const urlHash = window.location.hash;
if (urlHash) {
  const target = document.getElementById(urlHash.slice(1));
  if (target) {
    // ページトップから開始（ブラウザ差異を考慮して併用）
    history.replaceState(null, '', window.location.pathname);
    window.scrollTo(0, 0);

    window.addEventListener("load", () => {
      let position = target.getBoundingClientRect().top + window.scrollY - headerHeight;

      // スマホサイズの場合の追加オフセット
      if (window.innerWidth <= 768) { // 768px 以下をスマホと判断
        position += mobileOffset;
      }

      window.scrollTo(0, position);

      // ハッシュを再設定
      history.replaceState(null, '', window.location.pathname + urlHash);
    });
  }
}


/* ----- コンタクトフォーム設定 ----- */
document.addEventListener('DOMContentLoaded', () => {
    // 入力内容を格納するための変数
    let val;
    // 入力フィールドのタイプを格納するための変数
    let type;
    // ラジオボタンの選択値を格納するための変数
    let radio;
    // チェックボックスの選択値を格納するための変数
    let check;

    // ラジオボタンの初期値を取得し、確認画面に反映させる
    const radioButtons = document.querySelectorAll('[type="radio"]:checked');
    radioButtons.forEach(button => {
        // ラジオボタンの選択値を取得
        radio = button.value;
        // ラジオボタンの親要素からidを取得
        const id = button.closest('[id]').id;
        // 取得したidをクラス名に追加し、確認画面の値を設定
        document.querySelector(`.confirm_${id}`).textContent = radio;
    });

    // 入力フィールドの内容が変更された場合の処理
    const formInputs = document.querySelectorAll('.contactForm__item input, .contactForm__item select, .contactForm__item textarea');
    formInputs.forEach(input => {
        input.addEventListener('change', function () {
            // 入力内容を取得
            val = this.value;
            // 入力フィールドのタイプを取得
            type = this.getAttribute("type");
            // ラジオボタンの場合の処理
            if (type === "radio") {
                // ラジオボタンの選択値を取得
                radio = this.value;
                // ラジオボタンの親要素からidを取得
                const id = this.closest("[id]").id;
                // 取得したidをクラス名に追加し、確認画面の値を設定
                document.querySelector(`.confirm_${id}`).textContent = radio;
            }// チェックボックスの場合の処理
            else if (type === "checkbox") {
                // チェックボックスの選択値を取得
                check = this.value;
                // チェックボックスの親要素からidを取得
                const id = this.closest("[id]").id;
                // 取得したidをクラス名に追加し、確認画面の値を設定
                document.querySelector(`.confirm_${id}`).textContent += check + " / ";
            }// その他の場合の処理
            else {
                // 入力フィールドのidを取得
                const id = this.id;
                // 取得したidをクラス名に追加し、確認画面の値を設定
                document.querySelector(`.confirm_${id}`).textContent = val;
            }
        });
    });

    // 確認ボタンをクリックした場合の処理
    const confirmButton = document.querySelector(".confirm_button");
    confirmButton.addEventListener('click', () => {
      document.querySelector(".contactForm__first").style.display = 'none';
      document.querySelector(".phone").style.display = 'none';
        document.querySelector(".confirm_area").style.display = 'block';
      // window.scrollTo(0, document.querySelector('#navi').getBoundingClientRect().top);
              window.scrollTo(0, 0);  // ページを一番上にスクロール

    });

    // 戻るボタンをクリックした場合の処理
    const backButton = document.querySelector(".back_button");
    backButton.addEventListener('click', () => {
        document.querySelector(".contactForm__first").style.display = 'block';
        document.querySelector(".phone").style.display = 'block';
        document.querySelector(".confirm_area").style.display = 'none';
        window.scrollTo(0, document.querySelector('#navi').getBoundingClientRect().top);
    });

    // 必須項目が変更された場合の処理
    const requiredInputs = document.querySelectorAll('[aria-required="true"]');
    requiredInputs.forEach(input => {
        input.addEventListener('input', () => {
            // フラグ
            let flag = true;
            // 必須項目をループで確認
            requiredInputs.forEach(requiredInput => {
                if (requiredInput.value === "") {
                    flag = false;
                }
            });
            // フラグに基づいて確認ボタンを有効化/無効化
            confirmButton.disabled = !flag;
        });
    });

    // 送信ボタンをクリックした場合の処理
  document.addEventListener('wpcf7mailsent', (event) => {
        location = './contact-thanks/'; /* ----- ここにサンクスページのURL記載 ----- */
    }, false);
});



/* ----- フェードイン ----- */
document.addEventListener('DOMContentLoaded', function() {
  const fadeElements = document.querySelectorAll('.fade');

  // Intersection Observer のオプション設定
  const observerOptions = {
    threshold: 0.1 // 要素の10%が見えたら発火
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-active'); // 表示されたときにクラスを追加
        observer.unobserve(entry.target); // 一度発火したら監視を解除
      }
    });
  }, observerOptions);

  // すべてのフェード要素に対してオブザーバーを設定
  fadeElements.forEach(element => {
    observer.observe(element);
  });
});
